import APIService from '@/services/APIService';

import UserData from '@/models/list/UserData';

export default {

  index(params) {
    return APIService.get('/user-data', { params, rOptions: { model: UserData, many: true } });
  },

  show(id, params) {
    return APIService.get(`/user-data/${id}`, { params, rOptions: { model: UserData } });
  },

  create(data) {
    return APIService.post('user-data', data, { rOptions: { model: UserData } });
  },
};
